<script lang="ts" setup>
  import { computed, onMounted, watch } from "vue";
  import SimpleModal from "@/components/modals/SimpleModal.vue";
  import SubscriptionFlowWelcomeStep from "@/components/modals/subscription_flow/SubscriptionFlowWelcomeStep.vue";
  import SubscriptionFlowMembershipTierStep
    from "@/components/modals/subscription_flow/SubscriptionFlowMembershipTierStep.vue";
  import SubscriptionFlowBillingStep from "@/components/modals/subscription_flow/SubscriptionFlowBillingStep.vue";
  import SubscriptionFlowReferralStep from "@/components/modals/subscription_flow/SubscriptionFlowReferralStep.vue";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import { useAppStore } from "@/stores/app";
  import SubscriptionFlowSuccessStep from "@/components/modals/subscription_flow/SubscriptionFlowSuccessStep.vue";
  import SubscriptionFlowErrorStep from "@/components/modals/subscription_flow/SubscriptionFlowErrorStep.vue";
  import { useSessionStore } from "@/stores/session";
  import * as amplitude from "@amplitude/analytics-browser";
  import SubscriptionFlowConfirmDowngrade
    from '@/components/modals/subscription_flow/SubscriptionFlowConfirmDowngrade.vue'

  const appStore = useAppStore();
  const sessionStore = useSessionStore();
  const subscriptionFlowStore = useSubscriptionFlowStore();
  const step = computed(() => subscriptionFlowStore.step);

  onMounted(async () => {
    if (step.value === 'tier') {
      subscriptionFlowStore.checkMembershipModel();
    }
  });

  function handleModelUpdate(value: boolean) {
    value ? subscriptionFlowStore.showModal = true : subscriptionFlowStore.close();
  }

  watch(() => subscriptionFlowStore.showModal, (value) => {
    if (value) {
      amplitude.track('Subscription Modal Displayed');
    }
  });

</script>

<template>
  <SimpleModal
    :model-value="subscriptionFlowStore.showModal"
    @update:model-value="handleModelUpdate"
    :compact="step === 'tier'"
    width="800"
  >
    <SubscriptionFlowWelcomeStep v-if="step === 'welcome'"/>
    <SubscriptionFlowMembershipTierStep v-else-if="step === 'tier'"/>
    <SubscriptionFlowBillingStep v-else-if="step === 'card'"/>
    <SubscriptionFlowReferralStep v-else-if="step === 'referral'"/>
    <SubscriptionFlowSuccessStep v-else-if="step === 'success'"/>
    <SubscriptionFlowConfirmDowngrade v-else-if="step === 'review'"/>
    <SubscriptionFlowErrorStep v-else-if="step === 'error'"/>
  </SimpleModal>
</template>

<style lang="scss" scoped>
  :deep(.v-btn.full) {
    width: 100%;
    border-radius: 0.5rem;
  }
</style>